export const errorState = (formState: any) =>
  formState.isSubmitting ||
  !!formState.errors.email ||
  !!formState?.errors?.phone ||
  !!formState?.errors?.code;
